import { render, staticRenderFns } from "./ModerationList.vue?vue&type=template&id=31bd3800&lang=pug"
import script from "./ModerationList.vue?vue&type=script&lang=js"
export * from "./ModerationList.vue?vue&type=script&lang=js"
import style0 from "./ModerationList.vue?vue&type=style&index=0&id=31bd3800&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports